import script from "./ReportRowMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportRowMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ReportRowMenu.vue?vue&type=style&index=0&id=2832e4dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2832e4dd"]])

export default __exports__